




import { Component, Inject, Watch, Mixins } from 'vue-property-decorator';
import { AxiosInstance as ApiInstance } from 'axios';
import { remoteEduService } from '@/services';
import { eduData } from '@/pages/profile/utils';
import TestsModule from '../../tests';
import { LoaderMixin } from '@/pages/profile/mixins';
import store from '@/pages/profile/store';
import { ITests } from './types';

@Component({
  components: {
    TestsModule,
  },
  metaInfo: () => ({
    title: 'Тесты',
  }),
})
export default class Tests extends Mixins(LoaderMixin) implements ITests {
  @Inject() $api: ApiInstance;

  tests: Array<any> = [];

  get id(): string {
    return store.state.id;
  }

  @Watch('id', { immediate: true })
  onChangeChild(id: string): void {
    if (!id) return;
    this.getData();
  }

  // mounted() {
  //   if (!this.id) return;
  //   this.getData();
  // }

  async getData() {
    const { $api, id } = this;
    if (!id) return;
    this.setStatus('loading');
    try {
      const { data } = await remoteEduService($api).getRemoteEduTests(id);
      this.tests = eduData(data);
      this.setStatus('success');
    } catch (err) {
      this.setStatus('error');
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/views/tests/Tests.vue